import * as React from "react";
import { cn } from "lib/utils";
import { Icon, IconName } from "../icons/Icon";

export interface NavigatorButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconName;
  text: string;
  iconClassName?: string;
}

const NavigatorButton = React.forwardRef<HTMLButtonElement, NavigatorButtonProps>(
  ({ className, icon, text, iconClassName, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          "flex items-center gap-2 px-0 py-0 bg-transparent border-0 type-body-m text-[length:var(--body-s-font-size)] transition-colors cursor-pointer hover:text-foundation-orange-500 text-foundation-base-darkbase-dark-500",
          className
        )}
        {...props}
      >
        <Icon
          name={icon}
          className={cn(
            "w-5 h-5 text-inherit",
            iconClassName
          )}
        />
        <span className="whitespace-nowrap">{text}</span>
      </button>
    );
  }
);
NavigatorButton.displayName = "NavigatorButton";

export { NavigatorButton };


